"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const rebass_1 = require("rebass");
const meta_1 = require("../components/meta");
const layout_1 = require("../components/layout");
const PreLaunchPage = ({ data: { bgImage, contentfulPreLaunchPage: { body: { body }, lead: { lead }, meta, }, } }) => (React.createElement(layout_1.default, { hideFooter: true, hideHeader: true },
    React.createElement(Wrapper, { color: 'white', style: { backgroundImage: `url(${bgImage.childImageSharp.sizes.src})` } },
        React.createElement(meta_1.default, { meta: meta }),
        React.createElement(rebass_1.Box, { mt: [5, 6], px: 3 },
            React.createElement(rebass_1.Heading, { className: 'serif', fontSize: [6, 7], mb: 3 }, "Shoulder"),
            React.createElement(rebass_1.Heading, { fontSize: [2, 3], mb: 4 }, lead),
            React.createElement(rebass_1.Text, { mb: 4, mx: 'auto', style: { maxWidth: '500px' } }, body),
            React.createElement(rebass_1.Button, { bg: 'lightPurple', borderRadius: '20px', onClick: () => window.location.href = 'mailto:alex@shoulder.com', px: 3 }, "Contact us")))));
exports.default = PreLaunchPage;
exports.query = graphql `
  query preLaunchPageQuery {
    bgImage: file (relativePath: {eq: "hero-bg.jpg"}) {
      childImageSharp {
        sizes(maxWidth: 2400) {
          src
        }
      }
    }

    contentfulPreLaunchPage (contentful_id: {eq: "6U1oJ8iYVyGIUGSA26wIWg"}) {
      body {body}
      lead {lead}
  
      meta {
        description
        image {
          title
          file {url}
        }
        title
      }  
    }
  }`;
const Wrapper = rebass_1.Fixed.extend `
    background-position: center bottom;
    background-size: cover;
    bottom: 0;
    display: flex;
    left: 0;
    justify-content: center;
    right: 0;
    text-align: center;
    top: 0;
  `;



// WEBPACK FOOTER //
// ./src/pages/index.tsx